import { Row, RowProps } from 'react-aria-components'

export type TableRowProperties<T> = RowProps<T>

export const TableRow = <T extends object>({
    ...properties
}: Readonly<TableRowProperties<T>>): JSX.Element => {
    return <Row {...properties} />
}
